(function () {
    'use strict';

    angular
        .module('app')
        .directive('selectFilter', selectFilterDirective);

    function selectFilterDirective() {
        var directive = {
            restrict: 'AE',
            scope: {
                options: '=',
                ngModel: '=',
                ngChange: '&',
                extraOption: '@',
                ngDisabled: '=',
                api: '@',
            },
            controller: SelectFilterDirectiveController,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: '/templates/directives/select-filter.directive.html',
        };

        return directive;
    }

    SelectFilterDirectiveController.$inject = ['global', 'i18n', '$element', '$attrs', '$scope', 'alert', 'debug', '$timeout', 'selectFilterFactory',];

    function SelectFilterDirectiveController(global, i18n, $element, $attrs, $scope, alert, debug, $timeout, selectFilterFactory) {
        var vm = this,
            container = $element.children()
                .eq(0),
            button = container.children()
                .eq(0),
            replacementContainer = container.children()
                .eq(1)
                .children()
                .eq(0);

        vm.search = '';
        vm.isOpen = false;
        vm.canBeClosed = false;
        vm.selectOption = selectOption;
        vm.open = open;
        vm.close = close;
        vm.delayedClose = delayedClose;
        vm.isDesktop = global.isDesktop;
        vm.searchKeyEvents = searchKeyEvents;
        vm.openNewSchoolPrompt = openNewSchoolPrompt;
        vm.openNewGroupPrompt = openNewGroupPrompt;

        var api = {
            update: function(value){
                console.info(value);
            },
        };

        function activate(){
            selectFilterFactory.registerApi($attrs.api, api);
        }

        activate();

        angular.forEach(['defaultLabel', 'placeholder',], function (term) {
            if ($attrs[term]) {
                i18n.get($attrs[term])
                    .then(function (text) {
                        vm[term] = text;
                    });
            }
        });

        function selectOption(option) {
            vm.ngModel = option.value;
            vm.label = option.label;
            vm.subLabel = option.subLabel;
            vm.close();
            if (typeof vm.ngChange === 'function') {
                var callback = vm.ngChange();
                if (typeof callback === 'function') {
                    vm.ngChange()(option.value);
                }
            }
        }

        $scope.$watch('vm.ngModel', function (value) {
            vm.label = '';
            angular.forEach(vm.options, function (option) {
                if (option.value === value) {
                    selectOption(option);
                }
            });
        });

        function openNewSchoolPrompt() {
            vm.close();
            var promise = alert.prompt('create-new-school', { schoolNamePrefill: vm.search });
            $timeout(function () {
                document.getElementById('new-school-name')
                    .focus();
            }, 250);

            promise.then(function (response) {
                var schoolName = response.get('new-school-name'),
                    optionExisted = false;
                vm.options.forEach(function (school) {
                    if (schoolName.toLowerCase() === school.label.toLowerCase()) {
                        selectOption(school);
                        optionExisted = true;
                    }
                });
                if (!optionExisted) {
                    var newSchool = {
                        value: schoolName,
                        label: schoolName
                    };
                    vm.options.push(newSchool);
                    selectOption(newSchool);
                }

            }, function () {
                debug.log('New school modal closed');
            });
        }

        function openNewGroupPrompt() {
            vm.close();
            var promise = alert.prompt('create-new-group', { groupNamePrefill: vm.search });
            $timeout(function () {
                document.getElementById('new-group-name')
                    .focus();
            }, 250);

            promise.then(function (response) {
                var groupName = response.get('new-group-name'),
                    optionExisted = false;
                vm.options.forEach(function (group) {
                    if (groupName.toLowerCase() === group.label.toLowerCase()) {
                        selectOption(group);
                        optionExisted = true;
                    }
                });
                if (!optionExisted) {
                    var newGroup = {
                        value: groupName,
                        label: groupName
                    };
                    vm.options.push(newGroup);
                    selectOption(newGroup);
                }

            }, function () {
                debug.log('New group modal closed');
            });
        }

        function open() {
            if (!vm.ngDisabled) {
                vm.canBeClosed = false;
                $timeout(function () {
                    vm.isOpen = true;
                    $timeout(function () {
                        if (!global.isIOS && !global.isMobile) {
                            var element = $element[0];
                            element.querySelector('input')
                                .focus();
                        }
                        vm.canBeClosed = true;
                    }, 400);
                }, 100);
            }
        }

        function delayedClose() {
            if (vm.canBeClosed) {
                $timeout(function () {
                    close();
                }, 200);

            }
        }

        function close() {
            if (vm.canBeClosed) {
                vm.isOpen = false;
                vm.canBeClosed = false;
            }
        }

        function elementIsDescendant(parent, child) {
            var node = child.parentNode;
            while (node !== null) {
                if (node === parent) {
                    return true;
                }
                node = node.parentNode;
            }
            return false;
        }

        function clickOutsideHandler(ev) {
            if (vm.isOpen) {
                if (!elementIsDescendant(replacementContainer[0], ev.target) && ev.target !== replacementContainer[0] && !elementIsDescendant(button[0], ev.target) && ev.target !== button[0] && !elementIsDescendant(container[0], ev.target) && ev.target !== container[0]) {
                    vm.close();
                }
            }
        }

        function moveHighlighter(direction) {
            var index = -1;
            var optionElements = replacementContainer[0].querySelectorAll('li');
            for (var i = 0; i < optionElements.length; i++) {
                if (optionElements[i].className.indexOf('selected') !== -1) {
                    index = i;
                }
            }

            if (index !== -1) {
                optionElements[index].classList.remove('selected');
            }

            if (direction === 'up') {
                index = index - 1 < 0
                    ? optionElements.length - 1
                    : index - 1;
            } else {
                index = index + 1 >= optionElements.length
                    ? 0
                    : index + 1;
            }

            optionElements[index].classList.add('selected');
            optionElements[index].scrollIntoView(true);
        }

        function chooseHighlighted() {
            var index = -1;
            var optionElements = replacementContainer[0].querySelectorAll('li');
            for (var i = 0; i < optionElements.length; i++) {
                if (optionElements[i].className.indexOf('selected') !== -1) {
                    index = i;
                }
            }

            if (index === -1) {
                return;
            }

            optionElements[index].querySelector('a')
                .dispatchEvent(new Event('click'));

        }

        function searchKeyEvents(ev) {
            switch (ev.keyCode) {
                case 13:
                    chooseHighlighted();
                    break;
                case 27:
                    close();
                    break;
                case 38:
                    moveHighlighter('up');
                    break;
                case 40:
                    moveHighlighter('down');
                    break;
            }
        }

        angular.element(document)
            .on('click', clickOutsideHandler);

        $scope.$on('$destroy', function () {
            angular.element(document)
                .off('click', clickOutsideHandler);

            selectFilterFactory.removeApi($attrs.api);
        });
    }
})();